<template>
  <div
    ref="searchBar"
    id="searchBar"
    :style="`z-index: 1000; width: ${searchBarWidth}; max-width: ${searchBarMaxWidth}`"
  >
    <v-btn
      :title="$t('common.title_showLeftBar')"
      small
      fab
      v-if="
        !$parent.showLeftBar && $parent.$refs.leftBar.tryGoToValidDynamicTabs()
      "
      @click="$parent.chgShowLeftBar(true)"
      style="margin-right: 5px"
    >
      <v-icon>arrow_forward_ios</v-icon>
    </v-btn>
    <v-combobox
      id="searchBarInput"
      ref="searchBarInput"
      :title="$t('common.title_searchBar')"
      v-model="searchKeywordModel"
      solo
      clearable
      hide-no-data
      hide-details
      :items="autocompleteItems"
      :loading="loading"
      :no-data-text="$t('common.recordnotfound')"
      class="searchBarAutocomplete"
      :label="$t('common.searchPlace')"
      prepend-inner-icon="mdi-map-marker"
      :search-input.sync="searchKeywordModel"
      @click:clear="
        showSearchBarMenu = false;
        autocompleteItems = [];
      "
      @click="inputFocus()"
      @keydown.esc="showSearchBarMenu = false"
      @keydown.enter="
        ignoreShowSearchBarMenu = true;
        verifySearchBarSelection();
        fetchPlaces(searchKeywordModel);
      "
      :menu-props="{
        value: showSearchBarMenu,
        closeOnClick: true,
        closeOnContentClick: true,
        openOnClick: autocompleteItems.length > 0 ? true : false,
      }"
    >
      <template v-slot:append>
        <v-btn
          :disabled="!searchKeywordModel"
          icon
          @click.stop="fetchPlaces(searchKeywordModel)"
        >
          <v-icon>search</v-icon>
        </v-btn>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content
          @click="
            ignoreShowSearchBarMenu = true;
            $GA.search_place_autocomplete_item_click(item);
            fetchPlaces(item);
          "
          @keydown.enter="
            ignoreShowSearchBarMenu = true;
            $GA.search_place_autocomplete_search(item);
            fetchPlaces(item);
          "
          >{{ item }}</v-list-item-content
        >
      </template>
    </v-combobox>
  </div>
</template>

<script src="<%= BASE_URL %>lib/leaflet.js"></script>
<script>
import * as GLOBAL from "./Global.js";

export default {
  props: ["core"],
  data() {
    return {
      searchKeywordModel: null,
      showSearchBarMenu: false,
      ignoreShowSearchBarMenu: false,
      loading: false,
      autocompleteItems: [],
      // willClickInput: false,

      requestedUrl: null,
      searchBarWidth: "40vw",
      searchBarMaxWidth: "90vw",
    };
  },
  watch: {
    [`core.tableWidthSize`](newVal) {
      switch (newVal) {
        case "xl":
        case "lg":
        case "md":
        case "sm":
          this.searchBarMaxWidth = "40vw";
          break;
        case "xs":
          this.searchBarMaxWidth = "90vw";
          break;
      }
    },

    [`core.leftBarWidthSize`]() {
      this.updateSearchBarWidth();
    },

    searchKeywordModel(newVal, oldVal) {
      this.autocompleteItems = [];
      if (!newVal || newVal == "") {
        this.setNotShowSearchBarMenu();
      }
      this.fetchAutocomplete(this.searchKeywordModel);
    },
  },

  computed: {
    // searchBarWidth(newVal, oldVal) {
    //   if (core.tableWidthSize == "xs" || core.tableWidthSize == "sm") {
    //     return "30vw";
    //   } else {
    //     return "40vw";
    //   }
    // },
  },

  methods: {
    //for using keyboard to select the
    verifySearchBarSelection() {
      let element = $(".v-list-item--highlighted");
      if (element && element.length == 1) {
        this.searchKeywordModel = element.text();
      }
    },

    setNotShowSearchBarMenu() {
      let me = this;
      this.showSearchBarMenu = true;
      this.$nextTick(() => {
        me.showSearchBarMenu = false;
      });
    },

    updateSearchBarWidth() {
      try {
        this.searchBarWidth =
          $("#map").width() - $("#map_tools").width() - 50 + "px";
      } catch (e) {
        if (process.env.NODE_ENV == "development") {
          console.log(e);
        }
      }

      //   // console.log("updateSearchBarWidth")
      //   // let leftBarWidth = $("#leftBar").width();
      //   // let mapToolWidth = $("#map_tools").width();
      //   this.searchBarWidth =
      //     $(document).width() -
      //     (this.core.showLeftBar ? $("#leftBar").width() : 0) -
      //     $("#map_tools").width() -
      //     50 +
      //     "px";
    },

    inputFocus() {
      // fix ie out of focus
      setTimeout(() => {
        $("#searchBarInput").focus();
      }, 100);
    },

    loadControl() {
      let me = this;

      L.Control.SearchBar = L.Control.extend({
        options: {
          position: "topleft", //初始位置
        },
        initialize: function (options) {
          L.Util.extend(this.options, options);
        },
        onAdd: function (map) {
          this._container = L.DomUtil.create(
            "div",
            "leaflet-control-container"
          );
          let searchBar = me.$refs.searchBar;

          L.DomEvent.disableClickPropagation(searchBar);
          return searchBar;
        },
        _onCloseControl: function () {
          this._map.options.Legend = false;
          this.remove(this._map);
        },
      });
    },

    async fetchAutocomplete(tmpSearchKeyword) {
      if (!tmpSearchKeyword) {
        return;
      }

      this.setNotShowSearchBarMenu();

      this.searchKeywordModel = tmpSearchKeyword;
      this.loading = true;
      let url =
        GLOBAL.MAP_API_URL.AUTOCOMPLETE +
        `?autocomplete=${encodeURIComponent(tmpSearchKeyword)}`;
      this.requestedUrl = url;

      let res = await this.core.customFetch({ url: url });

      if (this.requestedUrl == url && res && typeof res == "object") {
        this.autocompleteItems = res;
        this.loading = false;

        if (this.ignoreShowSearchBarMenu) {
          this.ignoreShowSearchBarMenu = false;
        } else {
          this.showSearchBarMenu = true;
        }
      } else {
        this.autocompleteItems = [];
        this.loading = false;
      }
    },

    async fetchPlaces(tmpSearchKeyword) {
      //hidden keyboard for mobile
      document.activeElement.blur();
      $("input:focus").blur();
      window.focus();

      let me = this;

      this.setNotShowSearchBarMenu();

      //skip empty keyword
      if (!tmpSearchKeyword) {
        return;
      }

      // if (!tmpSearchKeyword || tmpSearchKeyword == ""){
      //   this.$parent.$refs["leftBar"].searchResult = []
      // }

      // this.$GA.search_place_autocomplete_search(this.searchKeyword);
      // this.$GA.search_place_autocomplete_item_click(tmpSearchKeyword);
      this.$GA.search_place_search_result_query(tmpSearchKeyword);

      this.loading = true;
      let url =
          GLOBAL.MAP_API_URL.SEARCH_PLACES +
          `?keyword=${encodeURIComponent(tmpSearchKeyword)}`,
        res = await this.core.customFetch({
          url: url,
          error_message: this.$t("common.errorSearchPlaceMessage"),
        });

      if (res && typeof res == "object") {
        this.$parent.$refs["leftBar"].keyword = tmpSearchKeyword;
        this.$parent.$refs["leftBar"].searchResult = res;

        this.loading = false;

        if (!me.core.showLeftBar) {
          me.core.chgShowLeftBar(true);
        }
      } else {
        // console.log(error);
        this.$parent.$refs["leftBar"].searchResult = null;
        this.loading = false;
        me.core.chgShowLeftBar(false);
      }
    },

    async getInfo() {
      this.loadControl();
      L.control.searchBar = function (options) {
        return new L.Control.SearchBar(options);
      };
    },
  },

  mounted() {
    this.getInfo();
  },
};
</script>


<style scoped lang="sass">
//fix v-container padding top bottom too big
.container
  padding-top: 0
  padding-bottom: 0

#searchBar
  .searchBarAutocomplete
    opacity: 0.9
</style>